import axios from 'axios';
import env from '../../config';
import { LessonRescheduleProposal } from '@opanuj/shared/types/api';
import { useMutation } from '@tanstack/react-query';

export type useLessonRescheduleProposalProps = {
	onSuccess: () => void
}

const useLessonRescheduleProposal = ({onSuccess}: useLessonRescheduleProposalProps) => {
	return useMutation({
		mutationFn: (data: LessonRescheduleProposal['body']) => {
			return axios.post(env.endpoints.lessonRescheduleProposal, data, {
				headers: {
					'Content-Type': 'application/json',
				},
			});
		},
		onSuccess
	})
};

export default useLessonRescheduleProposal;
